import React, { Component } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  Button,
  Modal,
  Container,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Table,
  Badge,
  Spinner,
  Input,
} from "reactstrap";
import {
  listTableBookingRequest,
  updateTablePaymentStatus,
} from "../../Endpoint/Admin/index";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

class TableBooking extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoaded: false,
      // Pagination
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      limit: 15,
      search: "",
      // Detail modal
      showDetailModal: false,
      selectedBooking: null,
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Table Bookings", link: "#" },
      ],
    };
  }

  componentDidMount() {
    this.getAllBookings();
  }

  getAllBookings = (page = this.state.currentPage, search = this.state.search) => {
    const { limit } = this.state;
    this.setState({ isLoaded: false });

    listTableBookingRequest(page, limit, search)
      .then((result) => {
        const pagination = result?.pagination || {};
        this.setState({
          isLoaded: true,
          items: result?.data || [],
          currentPage: pagination.currentPage || 1,
          totalPages: pagination.totalPages || 1,
          totalCount: pagination.totalCount || 0,
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isLoaded: true, items: [] });
      });
  };

  // View booking detail
  viewBookingDetail = (booking) => {
    this.setState({
      showDetailModal: true,
      selectedBooking: booking,
    });
  };

  closeDetailModal = () => {
    this.setState({
      showDetailModal: false,
      selectedBooking: null,
    });
  };

  // Update payment status
  StatusChangeRequest = (tableorderId, isPaymentSuccess) => {
    updateTablePaymentStatus(tableorderId, isPaymentSuccess)
      .then((response) => {
        if (response.status === 200) {
          toast.success(response.message);
          this.getAllBookings();
          this.closeDetailModal();
        } else {
          toast.error(response.message);
        }
      })
      .catch(() => toast.error("Error updating payment status"));
  };

  // Get payment badge
  getPaymentBadge = (booking) => {
    if (booking.isPaymentSuccess) return <Badge color="success">Paid</Badge>;
    return <Badge color="warning">Pending</Badge>;
  };

  // Get payment method label
  getPaymentMethodLabel = (type) => {
    return type === 1 ? "Cash" : "Online";
  };

  // Get person type label
  getPersonTypeLabel = (type) => {
    switch (type) {
      case "Single":
      case "single":
        return <Badge color="info">Single</Badge>;
      case "Couple":
      case "couple":
        return <Badge color="primary">Couple</Badge>;
      case "Family":
      case "family":
        return <Badge color="success">Family</Badge>;
      default:
        return <Badge color="secondary">{type || "N/A"}</Badge>;
    }
  };

  render() {
    const { items, isLoaded, currentPage, totalPages, totalCount, limit, search, selectedBooking } = this.state;

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Table Bookings" breadcrumbItems={this.state.breadcrumbItems} />

            {/* Detail Modal */}
            <Modal
              isOpen={this.state.showDetailModal}
              toggle={this.closeDetailModal}
              size="lg"
              scrollable
            >
              <ModalHeader toggle={this.closeDetailModal} className="bg-primary text-white">
                <i className="ri-restaurant-line mr-2"></i> Table Booking Details
              </ModalHeader>
              <ModalBody className="p-0">
                {selectedBooking && (
                  <div>
                    {/* Status Header */}
                    <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
                      <div>
                        <h5 className="mb-1">
                          {selectedBooking.bookingNumber || `#${selectedBooking._id?.slice(-6).toUpperCase()}`}
                        </h5>
                        <small className="text-muted">Booked on {selectedBooking.createdAt}</small>
                      </div>
                      <div>
                        {this.getPaymentBadge(selectedBooking)}
                      </div>
                    </div>

                    {/* Guest Info */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-user-line mr-1"></i> Guest Information
                      </h6>
                      <Row>
                        <Col md={6}>
                          <p className="mb-1"><strong>Name:</strong> {selectedBooking.user || "N/A"}</p>
                          <p className="mb-0"><strong>Email:</strong> {selectedBooking.email || "N/A"}</p>
                        </Col>
                        <Col md={6}>
                          <p className="mb-1"><strong>Phone:</strong> {selectedBooking.mobile || "N/A"}</p>
                          <p className="mb-0"><strong>Party Size:</strong> {this.getPersonTypeLabel(selectedBooking.person)}</p>
                        </Col>
                      </Row>
                    </div>

                    {/* Table Info */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-layout-grid-line mr-1"></i> Table Details
                      </h6>
                      <Row>
                        <Col md={6}>
                          <p className="mb-1"><strong>Table No:</strong> {selectedBooking.tableNo || "N/A"}</p>
                          <p className="mb-0"><strong>Capacity:</strong> {selectedBooking.tableCapacity || "N/A"} persons</p>
                        </Col>
                        <Col md={6}>
                          {selectedBooking.bookingDate && (
                            <p className="mb-1"><strong>Date:</strong> {selectedBooking.bookingDate}</p>
                          )}
                          {selectedBooking.bookingTime && (
                            <p className="mb-0"><strong>Time:</strong> {selectedBooking.bookingTime}</p>
                          )}
                        </Col>
                      </Row>
                    </div>

                    {/* Special Requests */}
                    {selectedBooking.specialRequests && (
                      <div className="p-3 border-bottom">
                        <h6 className="text-muted mb-1">
                          <i className="ri-chat-3-line mr-1"></i> Special Requests
                        </h6>
                        <p className="mb-0 font-italic">"{selectedBooking.specialRequests}"</p>
                      </div>
                    )}

                    {/* Payment Summary */}
                    <div className="p-3 border-bottom">
                      <h6 className="text-muted mb-2">
                        <i className="ri-money-dollar-circle-line mr-1"></i> Payment
                      </h6>
                      <Row>
                        <Col>
                          {/* Show original amount if there's a discount */}
                          {selectedBooking.couponCode && selectedBooking.couponDiscount > 0 && (
                            <>
                              <p className="mb-1">
                                <span className="text-muted">Subtotal:</span>{" "}
                                <span style={{ textDecoration: "line-through" }}>
                                  ${(selectedBooking.originalAmount || selectedBooking.tableBaseAmount || 0).toFixed(2)}
                                </span>
                              </p>
                              <p className="mb-1">
                                <Badge color="success" className="mr-1">
                                  <i className="ri-coupon-3-line mr-1"></i>
                                  {selectedBooking.couponCode}
                                </Badge>
                                <span className="text-success">
                                  -${(selectedBooking.couponDiscount || 0).toFixed(2)} off
                                </span>
                              </p>
                            </>
                          )}
                          <p className="mb-1">
                            <strong className="text-primary" style={{ fontSize: "1.2rem" }}>
                              {selectedBooking.couponDiscount > 0 ? "Final Total" : "Total"}: ${(selectedBooking.finalAmount || 0).toFixed(2)}
                            </strong>
                          </p>
                          <p className="mb-0">
                            Payment Method: {this.getPaymentMethodLabel(selectedBooking.paymentMethodType)}
                          </p>
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </ModalBody>
              <ModalFooter>
                {selectedBooking && !selectedBooking.isPaymentSuccess && selectedBooking.paymentMethodType === 1 && (
                  <Button
                    color="success"
                    size="sm"
                    onClick={() => this.StatusChangeRequest(selectedBooking._id, true)}
                  >
                    <i className="ri-check-line mr-1"></i> Mark as Paid
                  </Button>
                )}
                <Button color="secondary" size="sm" onClick={this.closeDetailModal}>
                  Close
                </Button>
              </ModalFooter>
            </Modal>

            {/* Main Content */}
            <Row>
              <Col xs={12}>
                <Card>
                  <CardBody>
                    {/* Header with Search */}
                    <Row className="mb-3 align-items-center">
                      <Col md={6}>
                        <div className="d-flex">
                          <Input
                            type="text"
                            placeholder="Search by guest name, email, phone, table..."
                            value={search}
                            onChange={(e) => this.setState({ search: e.target.value })}
                            onKeyPress={(e) => {
                              if (e.key === "Enter") this.getAllBookings(1, search);
                            }}
                            style={{ maxWidth: "300px" }}
                          />
                          <Button
                            color="primary"
                            className="ml-2"
                            onClick={() => this.getAllBookings(1, search)}
                          >
                            Search
                          </Button>
                          {search && (
                            <Button
                              color="light"
                              className="ml-2"
                              onClick={() => {
                                this.setState({ search: "" }, () => this.getAllBookings(1, ""));
                              }}
                            >
                              Clear
                            </Button>
                          )}
                        </div>
                      </Col>
                      <Col md={6} className="text-right">
                        <span className="text-muted">
                          {totalCount} bookings total
                        </span>
                      </Col>
                    </Row>

                    {/* Bookings Table */}
                    {!isLoaded ? (
                      <div className="text-center py-5">
                        <Spinner color="primary" />
                        <p className="mt-2 text-muted">Loading bookings...</p>
                      </div>
                    ) : items.length === 0 ? (
                      <div className="text-center py-5">
                        <i className="ri-restaurant-line" style={{ fontSize: "3rem", color: "#ccc" }}></i>
                        <p className="mt-2 text-muted">No table bookings found</p>
                      </div>
                    ) : (
                      <div className="table-responsive">
                        <Table hover className="mb-0" style={{ fontSize: "13px" }}>
                          <thead className="thead-light">
                            <tr>
                              <th style={{ width: "140px" }}>Booked On</th>
                              <th>Guest</th>
                              <th style={{ width: "80px" }}>Table #</th>
                              <th style={{ width: "100px" }}>Party Size</th>
                              <th style={{ width: "80px" }}>Amount</th>
                              <th style={{ width: "100px" }}>Payment</th>
                              <th style={{ width: "100px" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {items.map((booking, index) => (
                              <tr
                                key={booking._id || index}
                                onClick={() => this.viewBookingDetail(booking)}
                                style={{ cursor: "pointer" }}
                                className="booking-row"
                              >
                                <td>
                                  <small>{booking.createdAt}</small>
                                </td>
                                <td>
                                  <div>{booking.user || "N/A"}</div>
                                  <small className="text-muted">{booking.mobile}</small>
                                </td>
                                <td>
                                  <Badge color="dark" className="font-size-12">
                                    #{booking.tableNo || "N/A"}
                                  </Badge>
                                </td>
                                <td>
                                  {this.getPersonTypeLabel(booking.person)}
                                </td>
                                <td>
                                  <div>
                                    <strong>${(booking.finalAmount || 0).toFixed(2)}</strong>
                                    {booking.couponCode && booking.couponDiscount > 0 && (
                                      <>
                                        <br />
                                        <small className="text-success">
                                          <i className="ri-coupon-3-line"></i> -{booking.couponDiscount.toFixed(0)}
                                        </small>
                                      </>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  {this.getPaymentBadge(booking)}
                                </td>
                                <td onClick={(e) => e.stopPropagation()}>
                                  {!booking.isPaymentSuccess && booking.paymentMethodType === 1 ? (
                                    <Button
                                      color="warning"
                                      size="sm"
                                      onClick={() => this.StatusChangeRequest(booking._id, true)}
                                    >
                                      Mark Paid
                                    </Button>
                                  ) : (
                                    <span className="text-success">
                                      <i className="ri-check-double-line"></i> Complete
                                    </span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    )}

                    {/* Pagination */}
                    {totalPages > 1 && (
                      <Row className="mt-3">
                        <Col md={6}>
                          <span className="text-muted">
                            Page {currentPage} of {totalPages}
                          </span>
                        </Col>
                        <Col md={6}>
                          <div className="d-flex justify-content-end align-items-center">
                            <Button
                              color="light"
                              size="sm"
                              disabled={currentPage <= 1}
                              onClick={() => this.getAllBookings(currentPage - 1)}
                              className="mr-1"
                            >
                              Prev
                            </Button>

                            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                              let pageNum;
                              if (totalPages <= 5) {
                                pageNum = i + 1;
                              } else if (currentPage <= 3) {
                                pageNum = i + 1;
                              } else if (currentPage >= totalPages - 2) {
                                pageNum = totalPages - 4 + i;
                              } else {
                                pageNum = currentPage - 2 + i;
                              }
                              return (
                                <Button
                                  key={pageNum}
                                  color={currentPage === pageNum ? "primary" : "light"}
                                  size="sm"
                                  className="mr-1"
                                  onClick={() => this.getAllBookings(pageNum)}
                                >
                                  {pageNum}
                                </Button>
                              );
                            })}

                            <Button
                              color="light"
                              size="sm"
                              disabled={currentPage >= totalPages}
                              onClick={() => this.getAllBookings(currentPage + 1)}
                              className="mr-2"
                            >
                              Next
                            </Button>

                            <Input
                              type="select"
                              value={limit}
                              onChange={(e) => {
                                this.setState({ limit: parseInt(e.target.value) }, () => {
                                  this.getAllBookings(1);
                                });
                              }}
                              style={{ width: "70px" }}
                              bsSize="sm"
                            >
                              <option value={10}>10</option>
                              <option value={15}>15</option>
                              <option value={25}>25</option>
                              <option value={50}>50</option>
                            </Input>
                          </div>
                        </Col>
                      </Row>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
        <ToastContainer />

        <style jsx>{`
          .booking-row:hover {
            background-color: #f8f9fa !important;
          }
        `}</style>
      </React.Fragment>
    );
  }
}

export default TableBooking;
